'use client';
import ErrorLayout, { ErrorType } from '@/components/common/ErrorLayout';
import { COUNTDOWN_TIMER_START } from '@/helper/errors';
import React from 'react';

export default function NotFound(): React.JSX.Element {
  return <ErrorLayout type={ErrorType.NOT_FOUND} countdown={COUNTDOWN_TIMER_START} />;
}
